import styled from 'styled-components';
import bg from './../assets/images/errorbg.png';

export const ErrorContainer = styled.div`
	min-height: 100vh;
	margin: auto;
	background-position: center;
	background-size: cover;
	position: absolute;
	width: 100%;
	top: 0;
	left: 0;
	background-image: url(${bg});
	display: flex;
	justify-content: flex-end;
	align-items: center;
	.error-content {
		width: 45%;
		margin-top: 6%;
		.error_text {
			color: #01abc1;
			.oops {
				font-size: 3.5rem;
				font-family: 'LibreBaskerville-Bold';
				@media screen and (max-width: 1480px) {
					font-size: 3rem;
				}
			}
			.sth-wrong {
				font-family: 'Manrope-ExtraBold';
				margin-bottom: 0.5em;
				@media screen and (max-width: 1480px) {
					font-size: 1.2rem;
				}
			}
			.error-des {
				color: #000;
				margin-bottom: 1em;
				width: 65%;
				@media screen and (max-width: 1480px) {
					font-size: 0.8rem;
				}
			}
		}
		.go-home_btn {
			color: #fff !important;
			background-color: #01abc1 !important;
			border: 1px solid var(--main-color);
			border-radius: 0.5em;
			padding: 0.6rem 2em;
			font-size: 1rem;
			@media screen and (max-width: 1480px) {
				font-size: 0.8rem;
			}
		}
	}
`;
